import { CKO_PAYMENT_ERROR_KIND, type CkoPaymentErrorKind } from '@payments'

export const CKO_ERROR_MESSAGE: Record<CkoPaymentErrorKind, string> = {
  [CKO_PAYMENT_ERROR_KIND.DECLINED]: '您的卡片未通過授權，請確認卡片資訊或改用其他卡片。',
  [CKO_PAYMENT_ERROR_KIND.INVALID_CARD_INPUT]: '信用卡資料有誤，請確認卡號、有效期限與安全碼後再試一次。',
  [CKO_PAYMENT_ERROR_KIND.SESSION_EXPIRED]: '付款逾時或連線已失效，請重新整理頁面後再試一次。',
  [CKO_PAYMENT_ERROR_KIND.CONFIGURATION]: '此付款方式目前無法使用，請改用其他付款方式或稍後再試。',
  [CKO_PAYMENT_ERROR_KIND.RETRYABLE]: '付款暫時無法完成，請稍後再試一次。',
  [CKO_PAYMENT_ERROR_KIND.UNKNOWN]: '結帳失敗，請再試一次或改用其他付款方式。',
}
